import { gql } from "@apollo/client";

export const QUERY_FORM3457J_VERSION = gql`
  query studentForm3457J(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3457J(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      parent1
      parent2
      dateProvidedToParent
      parentInitials
      formAction
      formStatus
    }
  }
`;
